module.exports = __webpack_public_path__ + "img/index10.5440c1f7.png";